import React, { Fragment } from 'react';
import TransactionDetailsLoader from '../loaderComponents/TransactionDetailsLoader';
import FETCH from '../Fetch';
import { withRouter, Link } from 'react-router-dom';
import { toast } from './Notifier';
import { canDisableFee } from '../utils';
import { TransactionSuccessIcon, DaysRemainingIcon } from './Svg';

class TransactionDetails extends React.Component {
  state = {
    transactionDetailsData: null,
    receipt_url: null,
    transactionStatus: null,
    requeryReqPending: false,
    transactionRequeried: false
  };

  componentDidMount() {
    const {
      match: { params }
    } = this.props;

    FETCH.getTransactionDetails(params.transactionId)
      .then(res => {
        /*
         * set data to state
         */
        this.setState({
          transactionDetailsData: res.data[0],
          receipt_url: res.receipt_url,
          transactionStatus: this.interpreteStatus(res.data[0].payment_status)
        });
      })
      .catch(err => {
        return err;
      });
  }

  /* Helper Methods */
  /*
   * method to interpret status codes
   */
  interpreteStatus = transaction_status_code => {
    let status;
    switch (transaction_status_code) {
      case '0':
        status = 'pending';
        break;
      case '100':
        status = 'pending';
        break;
      case '00':
        status = 'success';
        break;
      case '01':
        status = 'success';
        break;
      case '02':
        status = 'failed';
        break;
      case '012':
        status = 'aborted';
        break;
      case '021':
        status = 'pending';
        break;
      case '026':
        status = 'No such order';
        break;
      default:
        status = 'failed';
    }
    return status;
  };

  /*
   *   method to formatt float value to price
   */
  formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2
  });

  /*
   *   method tocapitalize first letter of string
   */
  capitalizer = string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  //method to interprete Requery status code
  interpreteReqStatus = statusCode => {
    let status;
    switch (statusCode) {
      case '00':
      case '01':
        status = 'success';
        break;
      case '021':
        status = 'pending';
        break;
      default:
        status = 'failed';
    }
    return status;
  };

  /*
   *      method to requery payment
   */
  requeryPayment = rrr => {
    this.setState({ requeryReqPending: true });

    FETCH.requeryPayment(rrr)
      .then(async response => {
        await this.setState({
          requeryReqPending: false,
          transactionStatus: this.interpreteReqStatus(response.data.statusCode),
          transactionRequeried: true
        });

        this.state.transactionStatus !== 'success'
          ? this.state.transactionStatus === 'failed'
            ? toast(response.message, { status: 'error' })
            : toast(response.message, { status: 'error' })
          : toast(response.message, { status: 'success' });
      })
      .catch(error => {
        this.setState({ requeryReqPending: false });
        toast('Could not update profile check network connectivity', {
          status: 'error'
        });
      });
  };

  /*
   *   method to handle main button click
   */
  handleMainButtonClick = () => {
    if (this.state.requeryReqPending) return; //return if request is processing already
    switch (this.state.transactionStatus) {
      case 'success':
        window.open(
          this.state.receipt_url +
            this.state.transactionDetailsData.transaction_id
        );
        break;
      default: {
        this.queryFeesAndGetMatchingId(
          this.state.transactionDetailsData.transaction_id
        );
      }
    }
  };

  queryFeesAndGetMatchingId = async transaction_id => {
    this.setState({ requeryReqPending: true });
    let payment_id;
    await FETCH.getFees()
      .then(res => {
        let testId;
        Object.keys(res.data).forEach(key =>
          res.data[key].forEach(fee => {
            if (transaction_id === fee.paid_id) {
              payment_id = fee.payment_id;
              this.setState({ requeryReqPending: false });
              return;
            }
          })
        );

        this.props.history.push(`/fee/details/${payment_id}`);
      })
      .catch(err => toast(err.message, { status: 'error', timeout: 5 }));
  };

  /* End of Helper Methods */

  render() {
    let transactionDetailsData = this.state.transactionDetailsData;

    /*
     *    map needed props from state if data has arrived
     */

    if (this.state.transactionDetailsData) {
      return (
        <Fragment>
          <main className="main-content-area col col-12 col-xs-9 col-sm-8 col-md-9 col-lg-10 col-xl-10">
            <Link to="/transactions">
              <h1 className="small">
                <i className="fas fa-arrow-left" />
                My Transactions
              </h1>
            </Link>
            {/* card for registered courses display  */}
            <div className="row no-gutters">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row no-gutters">
                      <div className="col-xs-6 col-sm-6 col-md-12 col-lg-6 p-2">
                        Transaction Details
                      </div>
                    </div>
                  </div>
                  <div className="card-body p-0">
                    <div className="row m-0">
                      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-5 col-xl-5 order-2 order-sm-2 order-md-2 order-lg-1 order-xl-1 p-0 border-right">
                        <div className="payment-details">
                          <div className="detail-container">
                            <p className="text">
                              {this.state.transactionStatus === 'success'
                                ? 'Total amount paid'
                                : this.state.transactionStatus === 'pending'
                                ? 'Amount to be paid'
                                : 'Amount to be paid'}
                            </p>
                            <div className="amount">
                              {' '}
                              {this.formatter.format(
                                this.state.transactionDetailsData.total_amount
                              )}
                              <span>NGN</span>
                            </div>
                          </div>
                          <hr className="separator" />
                          <div className="detail-container">
                            <p className="text">
                              {this.state.transactionStatus === 'success'
                                ? 'Transaction completed at'
                                : 'Transaction date'}
                            </p>
                            <div className="amount text-light">
                              {this.state.transactionStatus === 'success'
                                ? this.state.transactionDetailsData
                                    .date_completed
                                : this.state.transactionDetailsData
                                    .date_performed}
                            </div>
                          </div>
                          <hr className="separator" />
                          <div className="detail-container">
                            <p className="text">Payment status</p>
                            <div className="amount text-light">
                              {this.state.transactionStatus === 'success' ? (
                                <div className="status mb-5">
                                  <TransactionSuccessIcon />
                                  {this.capitalizer(
                                    this.state.transactionStatus
                                  ) === 'Success'
                                    ? 'Successful'
                                    : this.capitalizer(
                                        this.state.transactionStatus
                                      )}
                                </div>
                              ) : (
                                <div className="row">
                                  <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 mb-5">
                                    <div className="status">
                                      <DaysRemainingIcon
                                        status={this.state.transactionStatus}
                                      />
                                      {this.capitalizer(
                                        this.state.transactionStatus
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 mb-5">
                                    <button
                                      className="btn w-100 custom-font-size mt-n3 p-3 btn-primary btn-gray"
                                      style={{
                                        display: this.state.transactionRequeried
                                          ? 'none'
                                          : 'block'
                                      }}
                                      onClick={() => {
                                        // if(canDisableFee(fee))
                                        this.requeryPayment(
                                          this.state.transactionDetailsData
                                            .transaction_ref
                                        );
                                      }}
                                    >
                                      {this.state.requeryReqPending ? (
                                        <i className="fas fa-circle-notch fa-spin" />
                                      ) : (
                                        <>
                                          <i className="fas fa-redo mr-2" />{' '}
                                          Re-Query Payment
                                        </>
                                      )}
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* button */}
                        <div className="footer">
                          {/* subtitute active class for disabled to either make button active or inactive */}
                          {/* handle "onClick" of print receipt button inline */}
                          <button
                            style={{
                              backgroundColor: this.state.requeryReqPending
                                ? '#02750e'
                                : '#00d715'
                            }}
                            disabled={this.state.requeryReqPending}
                            className="position-absolute fixed-bottom btn w-100 btn-primary-big btn-border-radius-payment active"
                            onClick={() => {
                              this.handleMainButtonClick();
                            }}
                            // button should be disabled until the user has requeried the payment or when the transaction status is success
                            // disabled={
                            //   !(
                            //     this.state.transactionRequeried ||
                            //     this.state.transactionStatus === 'success'
                            //   ) || this.state.requeryReqPending
                            // }
                          >
                            {this.state.requeryReqPending
                              ? 'Retrying ...'
                              : this.state.transactionStatus === 'success'
                              ? 'Print Receipt'
                              : 'Retry Payment'}
                          </button>
                        </div>
                      </div>
                      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-7 col-xl-7 order-1 order-sm-1 order-md-1 order-lg-2 order-xl-2 p-0">
                        <div className="payment-details">
                          <div className="row detail-container m-0">
                            <div className="col-lg-6 text">Payment details</div>
                            <div className="col-lg-6 text bold">
                              {
                                this.state.transactionDetailsData
                                  .payment_description
                              }
                            </div>
                          </div>
                          <hr className="separator" />
                          <div className="row detail-container m-0">
                            <div className="col-lg-6 text">Level</div>
                            <div className="col-lg-6 text bold">
                              {this.state.transactionDetailsData.level} Level
                            </div>
                          </div>

                          {/*
                          <hr className="separator" />
                           <div className="row detail-container m-0">
                            <div className="col-lg-6 text">Payment Method</div>
                            <div className="col-lg-6 text bold">Debit Card</div>
                          </div>
                          <hr className="separator" />
                          <div className="row detail-container m-0">
                            <div className="col-lg-6 text">Card Type</div>
                            <div className="col-lg-6 text bold">
                              MasterCard **** **** **** 7877
                            </div>
                          </div> */}
                          <hr className="separator" />
                          <div className="row detail-container m-0">
                            <div className="col-lg-6 text">RRR</div>
                            <div className="col-lg-6 text bold">
                              {this.state.transactionDetailsData.rrr_code}
                            </div>
                          </div>
                          <hr className="separator" />
                          <div className="row detail-container m-0">
                            <div className="col-lg-6 text">
                              Transaction ref.
                            </div>
                            <div className="col-lg-6 text bold">
                              {
                                this.state.transactionDetailsData
                                  .transaction_ref
                              }
                            </div>
                          </div>
                          <hr className="separator" />
                          <div className="row detail-container m-0">
                            <div className="col-lg-6 text">Total payment</div>
                            <div className="col-lg-6 text bold">
                              {this.state.transactionStatus === 'success'
                                ? this.formatter.format(
                                    this.state.transactionDetailsData
                                      .total_amount
                                  )
                                : this.formatter.format(
                                    this.state.transactionDetailsData
                                      .total_amount
                                  )}{' '}
                              NGN
                            </div>
                          </div>
                          <div className="row detail-container m-0">
                            <div className="col-lg-6 text-misc">
                              {
                                this.state.transactionDetailsData
                                  .payment_description
                              }
                            </div>
                            <div className="col-lg-6 text-misc">
                              {/* if (penaltyFee)  display  (payable amount - penalty fee) : else display (payable amount)*/}
                              {this.state.transactionStatus === 'success'
                                ? this.formatter.format(
                                    this.state.transactionDetailsData
                                      .penalty_fee
                                      ? this.state.transactionDetailsData
                                          .amount_paid -
                                          this.state.transactionDetailsData
                                            .penalty_fee
                                      : this.state.transactionDetailsData
                                          .amount_paid
                                  )
                                : this.formatter.format(
                                    this.state.transactionDetailsData
                                      .penalty_fee
                                      ? this.state.transactionDetailsData
                                          .total_amount -
                                          this.state.transactionDetailsData
                                            .penalty_fee
                                      : this.state.transactionDetailsData
                                          .total_amount
                                  )}{' '}
                              NGN
                            </div>
                          </div>
                          <div className="row detail-container m-0">
                            <div className="col-lg-6 text-misc">
                              {this.state.transactionDetailsData.payment_description.includes(
                                'School Fees'
                              )
                                ? 'Late Reg Fee'
                                : 'Other Charges'}
                            </div>
                            <div className="col-lg-6 text-misc">
                              {this.state.transactionDetailsData.penalty_fee
                                ? this.formatter.format(
                                    this.state.transactionDetailsData
                                      .penalty_fee
                                  )
                                : '0.00'}{' '}
                              NGN
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* card for outstanding fees */}
              </div>
            </div>
            {/* end card for news display   */}
          </main>
        </Fragment>
      );
    } else {
      return <TransactionDetailsLoader />;
    }
  }
}

export default withRouter(TransactionDetails);
